import * as angular from 'angular';
import 'angular-ui-router';
import 'ng-infinite-scroll';
import permissions from 'application/detail/permissions.json';
import { MessagesLogController } from 'modules/application/detail/growth/messages/log/MessagesLogController';
import MessagesLogView from './log/MessagesLogView.html';
import message from 'modules/message';
//
export const messages = angular
    .module('messages', ['ui.router', 'infinite-scroll', message])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('auth.application.detail.growth.messages', {
            url: '/messages',
            redirectTo: 'auth.application.detail.growth.messages.log',
            data: {
                permissionClaim: permissions.logMessages.claim,
            },
            params: { area: 'logMessages' },
        })
            .state('auth.application.detail.growth.messages.log', {
            url: '/log',
            views: {
                'content@auth.application.detail': {
                    template: MessagesLogView,
                    controller: MessagesLogController,
                    controllerAs: '$ctrl',
                },
                'sidenav@auth.application.detail': {},
            },
            data: {
                permissionClaim: permissions.logMessages.claim,
            },
            params: { area: 'logMessages' },
        });
    }])
    .run(['$rootScope', '$window', 'TEXT', function ($rootScope, $window, TEXT) {
        let unreadMessages = 0;
        $rootScope.$on('newMessages', (event, args) => {
            unreadMessages += args.count;
            changeTitle();
        });
        $rootScope.$on('messagesRead', () => {
            unreadMessages = 0;
            changeTitle();
        });
        const changeTitle = () => {
            $window.document.title =
                unreadMessages > 0
                    ? TEXT.pageTitle +
                        ' (' +
                        (unreadMessages >= 30 ? '30+' : unreadMessages) +
                        ')'
                    : TEXT.pageTitle;
        };
    }]).name;
